export const RESULT = {
  STATUS: 'status',
  SEEN: 'seen',
  RESULTS: 'results',
  HAZARD_PERCEPTION: 'hazard_perception',
  KNOWLEDGE: 'knowledge',
  HAS_PASSED: 'has_passed',
  INSIGHT: 'insight',
  MISTAKE: 'mistake',
  HAS_ZERO_MISTAKES: 'has_zero_mistakes',
  HAS_NOT_CAME: 'has_not_came',
  CAN_BE_LOADED: 'can_be_loaded',
  HAS_COME_TO_COURSE: 'has_come_to_course',
  HAS_MANY_MISTAKES: 'has_many_mistakes'
}

export const RESULT_STATUS = {
  FETCHING: 'Fetching',
  LOADED: 'Loaded',
  FAILED: 'Failed'
}

export default class ResultReservedExam  {
  constructor(item = {}) {
    this.status = item[RESULT.STATUS] || ''
    this.seen = item[RESULT.SEEN] || ''
    this.results = item[RESULT.RESULTS] || ''
    this.hazard_perception = item[RESULT.HAZARD_PERCEPTION] || ''
    this.knowledge = item[RESULT.KNOWLEDGE] || ''
    this.insight = item[RESULT.INSIGHT] || ''
    this.mistake = item[RESULT.MISTAKE] || ''
    this.hasPassed = item[RESULT.HAS_PASSED] || ''
    this.hasZeroMistakes = item[RESULT.HAS_ZERO_MISTAKES] || ''
    this.has_many_mistakes = item[RESULT.HAS_MANY_MISTAKES]
    this.notCame = item[RESULT.HAS_NOT_CAME] || ''
    this.canBeLoaded = item[RESULT.CAN_BE_LOADED],
    this.hasComeToCourse = item[RESULT.HAS_COME_TO_COURSE]
  }

  getApiData() {
    return {
      results: this.results,
      // hazard_perception: typeof this.hazard_perception === 'number' || this.hazard_perception.length ? this.hazard_perception : null,
      // knowledge: typeof this.knowledge === 'number' || this.knowledge.length ? this.knowledge : null,
      // insight: typeof this.insight === 'number' || this.insight.length ? this.insight : null,
    }
  }
}

export class ResultReservedExamFormValidationFields {
  constructor() {
    this.hazard_perception = 'hazard_perception'
    this.results = 'results'
    this.knowledge = 'knowledge'
    this.insight = 'insight'
  }
}